import * as types from '../actions';

const initialState = {
    termsItems: [],
    status:0,
    activity:'',
    errorData:''    
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {
        case types.TERMS_FETCH_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    termsItems: response.data,
                    status: response.status,
                    activity:types.TERMS_FETCH_SUCCESS+timeVar,   
                };
            }else{
                return {
                    ...state,
                    status: response.status,   
                    activity:types.TERMS_FETCH_ERROR+timeVar,                              
                };
            }

        case types.TERMS_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    termsItems: response.data,
                    status: response.status,
                    activity:types.TERMS_ADD_SUCCESS+timeVar,
                }
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.TERMS_ADD_ERROR+timeVar,
                    errorData: response.data,         
                }    
            }    

        case types.TERMS_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    termsItems: response.data,
                    status: response.status,
                    activity:types.TERMS_UPDATE_SUCCESS+timeVar,         
                }   
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.TERMS_UPDATE_ERROR+timeVar,
                    errorData: response.data,         
                }    
            }         
        
        case types.TERMS_LOAD_SUCCESS:
            return { ...state, 
                termsLoadActivity: types.TERMS_LOAD_SUCCESS+timeVar, 
                termsData: response.data, 
                termsStatus: response.status, 
                response
             };
        case types.TERMS_LOAD_ERROR:
            return { ...state, 
                termsLoadActivity: types.TERMS_LOAD_ERROR+timeVar,
                termsStatus: response.status, 
                errorData: response.statusText,
                response 
            };  
        
        case types.TERMS_ACCEPT_SUCCESS:
            console.log(JSON.stringify(response))
            return { ...state, 
                termsLoadActivity: types.TERMS_ACCEPT_SUCCESS+timeVar, 
                termsAcceptData: response.data, 
                termsAcceptStatus: response.status, 
                response
             };
        case types.TERMS_ACCEPT_ERROR:
            return { ...state, 
                termsLoadActivity: types.TERMS_ACCEPT_ERROR+timeVar,
                termsAcceptStatus: response.status ? response.status : null, 
                errorData: response.statusText,
                response 
            };   
            
       
        case types.CLEAR:
            return {
                ...state,
                termsItems: [],
                activity:'',
                status:0                
            }  

        default:
            return state;
    }
  };